import ImportDocumentModal from './ImportDocumentModal';

export default ImportDocumentModal;
